import { useCallback, useEffect, useState } from "react";

import { getBonusBalance } from "../api/api";
import { useAuthUser } from "./useTelegram";

/** Баланс бонусов: из профиля после логина + актуализация с /api/bonus/balance */
export function useBonusBalance(refreshKey) {
  const authUser = useAuthUser();
  const [balance, setBalance] = useState(() => {
    const b = authUser?.bonus_balance;
    return typeof b === "number" && Number.isFinite(b) ? b : 0;
  });

  const refresh = useCallback(() => {
    getBonusBalance()
      .then((data) => {
        const b = data?.balance;
        if (typeof b === "number" && Number.isFinite(b)) {
          setBalance(b);
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh, refreshKey]);

  useEffect(() => {
    const b = authUser?.bonus_balance;
    if (typeof b === "number" && Number.isFinite(b)) {
      setBalance(b);
    }
  }, [authUser?.bonus_balance]);

  return { balance, refresh };
}
